module.exports = EntrySoundEditor;